import { useDocumentTitle } from "@/lib/use-document-title";
import { StaffLayout } from "@/components/StaffLayout";
import { BenefitsAdmin } from "@/routes/af-portal.admin";

export default function AfPortalFormaner() {
  useDocumentTitle("Förmåner — ÅF-Portal");
  return (
    <StaffLayout title="Förmåner">
      <p className="text-muted-foreground mb-6 max-w-2xl">Hantera förmåner som medlemmar kan aktivera och boka.</p>
      <BenefitsAdmin />
    </StaffLayout>
  );
}
